import {Component, Input, OnInit} from '@angular/core';
import {ClientService} from '../services/client.service';
import {HistoryService} from '../services/history.service';
import {NgFor, NgIf} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';

@Component({
  selector: 'fmc-privacy-dialog',
  templateUrl: './privacy-dialog.component.html',
  styleUrls: ['./privacy-dialog.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    MatButtonModule
  ]
})
export class PrivacyDialogComponent implements OnInit {
  @Input() public borrower: any;
  @Input() public appId: any;
  @Input() public entityType: any;
  public privacyVerified = false;

  constructor(public clientService: ClientService,
              public historyService: HistoryService) { }

  ngOnInit() {
    console.log(this.borrower);

    if (this.borrower) {
      this.getPrivacyData();
    }
  }

  getPrivacyData() {
    const partyId = (this.borrower.person && this.borrower.person.PartyID) ?
      this.borrower.person.PartyID : (this.borrower.party && this.borrower.party.party) ?
        this.borrower.party.party.iD : (this.borrower.PrimaryContactPartyID) ?
          this.borrower.PrimaryContactPartyID : (this.borrower.PartyID) ?
            this.borrower.PartyID : null;

    if (partyId) {
      this.clientService.getPartyEmailAddresses(partyId)
        .subscribe(data => {
          this.borrower.emailAddressList = data;
        });

      this.clientService.getPartyPhoneList(partyId)
        .subscribe(data => {
          this.borrower.phoneList = data;
        });

      this.clientService.getPartyAddresses(partyId)
        .subscribe(data => {
          this.borrower.addressList = data;
        });
    }
  }

  verifyPrivacy(verified) {
    if (verified) {
      this.privacyVerified = true;
      let text: string;
      if (this.borrower.person) {
        text = `The privacy data for borrower ${this.borrower.person.firstName} ${this.borrower.person.lastName} has been verified`;
      } else if (this.borrower.company) {
        text = `The privacy data for borrower ${this.borrower.company.companyName} has been verified`;
      } else if (this.borrower.trust) {
        text = `The privacy data for borrower ${this.borrower.trust.trustName} has been verified`;
      }

      const body = { __t: 'text-note', title: 'Privacy verified', text: text, category: 'automatic' };
      this.historyService.createHistoryNote(this.entityType, this.appId, body)
        .subscribe(
          status => {
            console.log(status);
            // this.notificationService.notify('success', 'The history note has been created', 'Success' );
          },
          error => {
            console.log(error);
            // this.notificationService.notify('error', 'We could not process the creation of this history note', 'Error' );
          });
    }
  }
}
